/**
 * Bug Report Phase Configuration
 * 
 * Single source of truth for bug report status/phase column definitions.
 * This file defines the visual appearance and properties of each phase column
 * in the bug reports Kanban board.
 */

import { BugStatus } from 'shared/types/bug-report';

export interface BugPhaseColumn {
  id: BugStatus;
  label: string;
  color: string;
  bgColor: string;
  headerBgColor: string;
  borderColor: string;
}

/**
 * Bug Phase Columns
 * Defines all available bug phase/status columns with their styling
 */
export const bugPhaseColumns: BugPhaseColumn[] = [
  {
    id: BugStatus.REPORTED,
    label: 'Gemeld',
    color: 'text-blue-700',
    bgColor: 'bg-blue-50/50',
    headerBgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
  },
  {
    id: BugStatus.BACKLOG,
    label: 'Backlog',
    color: 'text-sky-700',
    bgColor: 'bg-sky-50/50',
    headerBgColor: 'bg-sky-50',
    borderColor: 'border-sky-200',
  },
  {
    id: BugStatus.IN_PROGRESS,
    label: 'In behandeling',
    color: 'text-moss-primary',
    bgColor: 'bg-moss-primary/5',
    headerBgColor: 'bg-moss-primary/10',
    borderColor: 'border-moss-primary/20',
  },
  {
    id: BugStatus.TESTING,
    label: 'Testing',
    color: 'text-purple-700',
    bgColor: 'bg-purple-50/50',
    headerBgColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
  },
  {
    id: BugStatus.RESOLVED,
    label: 'Opgelost',
    color: 'text-status-good',
    bgColor: 'bg-status-good/5',
    headerBgColor: 'bg-status-good/10',
    borderColor: 'border-status-good/20',
  },
  {
    id: BugStatus.PARKED,
    label: 'Geparkeerd',
    color: 'text-amber-700',
    bgColor: 'bg-amber-50/50',
    headerBgColor: 'bg-amber-50',
    borderColor: 'border-amber-200',
  },
  {
    id: BugStatus.CLOSED,
    label: 'Gesloten',
    color: 'text-neutral-600',
    bgColor: 'bg-neutral-50/50',
    headerBgColor: 'bg-neutral-50',
    borderColor: 'border-neutral-200',
  },
];

